import { render, staticRenderFns } from "./MapYandex.vue?vue&type=template&id=0a549d75&scoped=true"
import script from "./MapYandex.vue?vue&type=script&lang=js"
export * from "./MapYandex.vue?vue&type=script&lang=js"
import style0 from "./MapYandex.vue?vue&type=style&index=0&id=0a549d75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a549d75",
  null
  
)

export default component.exports